export enum IdoStage {
  PRESALE = "pre-sale",
  SALE = "sale",
  CLAIM = "claim",
}
